(function () {
  function getProductId() {
    try {
      var product = window.ShopifyAnalytics
        && window.ShopifyAnalytics.meta
        && window.ShopifyAnalytics.meta.product;
      return product && product.id ? String(product.id) : null;
    } catch (e) {
      return null;
    }
  }
  var pendingEmail = null;
  var pendingRecipientEmail = null;
  // Step 1: capture form values when the "Send Hint" <a> button is clicked.
  // The Drop Hint app uses an <a> inside #u_content_button_1_sendHint (not a <buttontype="submit">),
  // so native form submit events never fire.
  document.addEventListener('click', function (e) {
    var sendBtn = e.target.closest
      ? e.target.closest('#u_content_button_1_sendHint a')
      : null;
    if (!sendBtn) return;
    var modal = document.getElementById('hint_modal');
    if (!modal) return;
    var emailInput = modal.querySelector('input[name="your_email"]');
    var recipientInput = modal.querySelector('input[name="receiver_email"]');
    pendingEmail = emailInput ? emailInput.value : '';
    pendingRecipientEmail = recipientInput ? recipientInput.value : '';
  }, true);
  // Step 2: fire TriplePixel only when the app shows the success screen
  // (#hint_modal_closing switches from display:none to display:block on success).
  function watchForSuccess() {
    var closingModal = document.getElementById('hint_modal_closing');
    if (!closingModal) return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName !== 'style') continue;
        var isVisible = !/display\s*:\s*none/i.test(closingModal.getAttribute('style') ||
        '');
        if (!isVisible || !pendingEmail) continue;
        if (typeof TriplePixel !== 'function') {
          pendingEmail = null;
          return;
        }
        var payload = {
          formType: 'dropHint',
          pageUrl: window.location.href,
          email: pendingEmail
        };
        var productId = getProductId();
        if (productId) payload.productId = productId;
        console.log(payload)
        TriplePixel('custom', 'dropHint', payload);
        pendingEmail = null;
      }
    }).observe(closingModal, { attributes: true, attributeFilter: ['style'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForSuccess);
  } else {
    watchForSuccess();
  }
})();